const BannerBranding = ({ copy }) => (
  <div className="banner-branding">
    <p>{copy}</p>
    <i className="banner-logo" />
  </div>
);

export default BannerBranding;
